export enum Schedule {
  ACTIVE = 'Active',
  WEEKDAY = 'Weekday',
  WEEKEND = 'Weekend',
}
